import { SVGProps } from 'react'

const WalletOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.02 9.45a.833.833 0 1 0 1.665 0 .833.833 0 0 0-1.665 0Zm1.076 0a.244.244 0 0 1-.487 0 .244.244 0 0 1 .487 0ZM3.034 3.95h10.374a.293.293 0 1 0 0-.588H3.034a.294.294 0 1 0 0 .588Z"
    />
    <path
      fill="currentColor"
      d="M15.422 3.653c0-.96-.782-1.74-1.745-1.74H3.167c-.452 0-.902.186-1.234.511a1.744 1.744 0 0 0-.511 1.229v8.694c0 .959.782 1.74 1.745 1.74h10.51c.467 0 .905-.183 1.234-.512a1.73 1.73 0 0 0 .51-1.228V3.653ZM2.348 2.844c.22-.217.52-.341.819-.341h10.51c.635 0 1.153.513 1.155 1.146l-.002.007v1.6a1.725 1.725 0 0 0-1.153-.447H3.167a1.156 1.156 0 0 1-1.155-1.155c0-.302.122-.598.336-.81Zm12.484 7.758H9.87c-.633 0-1.15-.518-1.15-1.155 0-.31.12-.597.342-.814.211-.217.498-.336.808-.336h4.963v2.305Zm0-2.895H9.87a1.7 1.7 0 0 0-1.225.508c-.33.324-.513.761-.513 1.23 0 .963.78 1.745 1.74 1.745h4.963v1.155c0 .304-.12.593-.338.812a1.144 1.144 0 0 1-.817.338H3.167a1.154 1.154 0 0 1-1.155-1.15V4.949c.308.275.71.448 1.155.448h10.51c.632 0 1.145.51 1.153 1.138v.017l.002.01v1.145Z"
    />
  </svg>
)
export default WalletOutlineIcon
